import React, { PropsWithChildren } from 'react';
import {
    MappedComponentProperties,
} from '@adobe/aem-react-editable-components';

import './ArticleRichtext.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { useWidthContext } from '../../providers/Width';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Row, Image } from '../../importCL';


interface IArticleRichtextProps extends MappedComponentProperties {
	mobileSideImage?: string;
	sideImage?: string;
	sideImagePlacement?: string;
	sideImageCaption?: string;
	sideImageAltText?: string;
	sideImageLink?: string;
	bottomImage?: string;
	bottomImageCaption?: string;
	bottomImageAltText?: string;
	bottomImageLink?: string;
	text?: string;
	mobileBottomImage?: string;
}

export const ArticleRichtextEditConfig = {
    emptyLabel: 'Article Richtext',
    isEmpty: (props: PropsWithChildren<IArticleRichtextProps>) => {
        return !props || !props.text;
    },
};

const ArticleRichtext = (
    props: PropsWithChildren<IArticleRichtextProps>,
): JSX.Element => {
    const { width } = useWidthContext();
    
    return (
        <div
            id='article-rich-text'
            className='ArticleRichtext'
        >
            {width > 768 ? (
                props.sideImage && (
                    <div
                        title='Placement'
                        className='pb-6 hover:cursor-pointer'
                        style={
                            props.sideImagePlacement === 'left'
                                ? { float: 'left', marginRight: '2rem' }
                                : { float: 'right', marginLeft: '2rem' }
                        }
                    >
                        {props.sideImageLink ? (
                            <LinkWrapper className='Image__link' href={props.sideImageLink}>
                                <Image loading='lazy' src={props.sideImage} alt={props.sideImageAltText} />
                            </LinkWrapper>
                        ) : (
                            <Image loading='lazy' src={props.sideImage} alt={props.sideImageAltText} />
                        )}
                        <figcaption className='ArticleRichtext__figcaption'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.sideImageCaption))}
                        </figcaption>
                    </div>
                )
            ) : props.mobileSideImage ? (
                <div className='flex flex-col items-center justify-center w-full'>
                    {props.sideImageLink ? (
                        <LinkWrapper className='Image__link' href={props.sideImageLink}>
                            <Image loading='lazy' src={props.mobileSideImage} alt={props.sideImageAltText} />
                        </LinkWrapper>
                    ) : (
                        <Image loading='lazy' src={props.mobileSideImage} alt={props.sideImageAltText} />
                    )}
                    <figcaption className='mb-8'>
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(props.sideImageCaption))}
                    </figcaption>
                </div>
            ) : (
                props.sideImage && (
                    <div className='flex flex-col items-center justify-center w-full'>
                        {props.sideImageLink ? (
                            <LinkWrapper className='Image__link' href={props.sideImageLink}>
                                <Image loading='lazy' src={props.sideImage} alt={props.sideImageAltText} />
                            </LinkWrapper>
                        ) : (
                            <Image loading='lazy' src={props.sideImage} alt={props.sideImageAltText} />
                        )}
                        <figcaption className=' text-xs caption-bottom items-center'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.sideImageCaption))}
                        </figcaption>
                    </div>
                )
            )}
            <div>
                {props.text && transformHTMLParserLinks(props.text)}
            </div>
            {width > 768 ? (
                props.bottomImage && (
                    <Row
                        className='flex flex-col w-full'
                        justify='center'
                        align='center'
                    >
                        {props.bottomImageLink ? (
                            <LinkWrapper className='Image__link' href={props.bottomImageLink}>
                                <Image loading='lazy' src={props.bottomImage} alt={props.bottomImageAltText} />
                            </LinkWrapper>
                        ) : (
                            <Image loading='lazy' src={props.bottomImage} alt={props.bottomImageAltText} />
                        )}
                        <figcaption className='ArticleRichtext__figcaption'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.bottomImageCaption))}
                        </figcaption>
                    </Row>
                )
            ) : props.mobileBottomImage ? (
                <Row
                    className='ArticleRichtext__image--bottom'
                    justify='center'
                    align='center'
                >
                    {props.bottomImageLink ? (
                        <LinkWrapper className='Image__link' href={props.bottomImageLink}>
                            <Image
                                loading='lazy'
                                src={props.mobileBottomImage}
                                alt={props.bottomImageAltText}
                            />
                        </LinkWrapper>
                    ) : (
                        <Image
                            loading='lazy'
                            src={props.mobileBottomImage}
                            alt={props.bottomImageAltText}
                        />
                    )}
                    <figcaption className='ArticleRichtext__figcaption'>
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(props.bottomImageCaption))}
                    </figcaption>
                </Row>
            ) : (
                props.bottomImage && (
                    <Row
                        className='flex flex-col w-full'
                        justify='center'
                        align='center'
                    >
                        {props.bottomImageLink ? (
                            <LinkWrapper className='Image__link' href={props.bottomImageLink}>
                                <Image loading='lazy' src={props.bottomImage} alt={props.bottomImageAltText} />
                            </LinkWrapper>
                        ) : (
                            <Image loading='lazy' src={props.bottomImage} alt={props.bottomImageAltText} />
                        )}
                        <figcaption className='ArticleRichtext__figcaption'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.bottomImageCaption))}
                        </figcaption>
                    </Row>
                )
            )}
        </div>
    );
};

export default ArticleRichtext;
